Ext.define('WindowPojazdLicznik', {
    extend: 'Ext.ux.window.WindowExd',
    title: Lang.edycja_stanu_licznika,
    closable: false,
    collapsible: false,
    modal: true,
    resizable: false,
    scrollable: true,
    autoHeight: true,
    width: 600,
    layout: "fit",
    dane: {},
    initComponent: function () {
        this.cid = Ext.id();
        this.items = [{
            xtype: 'form',
            bodyStyle: {
                background: '#f1f1f1',
                padding: '5px'
            },
            items: [{
                xtype: 'numberfield',
                itemId: "stanlicznika",
                fieldLabel: Lang.stan_licznika,
                labelAlign: "left",
                minValue: 0
            }, {
                xtype: 'displayfield',
                itemId: "lastupdate",
                fieldLabel: Lang.data_ostatniego_tankowania
            }, {
                xtype: 'displayfield',
                fieldLabel: Lang.historia_licznika + ':'
            }, {
                xtype: 'grid',
                itemId: 'containerGrid',
                columns: [{
                    text: Lang.czas_tankowania,
                    dataIndex: 'czas',
                    flex: 1
                }, {
                    text: Lang.stan_licznika,
                    dataIndex: 'licznik',
                    flex: 1
                }],
                store: {
                    autoLoad: false,
                    model: Ext.define(null, {
                            extend: 'Ext.data.Model',
                            idProperty: 'id',
                            fields: [{
                                name: 'czas',
                                mapping: 'czas'
                            }, {
                                name: 'licznik',
                                mapping: 'licznik'
                            }],
                            proxy: {
                                type: 'memory',
                                reader: {
                                    type: 'json',
                                    rootProperty: 'data'
                                }
                            }
                    })
                }
            }]
        }];
        this.buttons = [{
            text: Lang.zapisz,
            scope: this,
            handler: this.saveLicznikState
        }, {
            text: Lang.anuluj,
            scope: this,
            handler: this.closeOp
        }];
        this.callParent(arguments);
    },
    saveLicznikState: function () {
        var stanLicznika = this.down("#stanlicznika").getValue();
        sendAjaxDataJsonRpcL("rest/pojazdy/updatePojazdState", {
            id: this.dane["pojazdid"],
            stanlicznika: stanLicznika,
            onlyPojazd: this.dane["onlyPojazd"],

        }, this, function (data) {
            if (data.status) {
                this.fireEvent("wclose", stanLicznika);
                this.close();
            } else {
                Ext.MessageBox.alert(Lang.error, data.error);
            }
        });
    },
    showW: function () {
        sendAjaxDataJsonRpcL("rest/tankowania/getSlHistoryList?pojazdid=" + this.dane["pojazdid"], {
        }, this, function (data) {
            if (data.status && data.data != null) {
                data = data.data;
                this.down("#containerGrid").getStore().loadData(data);
                this.obiekt = data;
                this.down("#stanlicznika").setValue(this.dane["stanlicznika"]);
                if (this.dane["onlyPojazd"]) {
                    this.down("#lastupdate").setHidden(true);
                } else {
                    this.down("#lastupdate").setValue(this.dane["lastupdate"]);
                }
                this.show();
            } else {
                Ext.MessageBox.alert(Lang.error, data.error);
            }
        });
    },
    closeOp: function () {
        this.close();
    }
});
